import PagePlaceholder from '@/components/PagePlaceholder';

export default function CustomSoftwarePage() {
  return (
    <PagePlaceholder
      title="Custom Software"
      subtitle="Applications and systems shaped around your workflows, users and business rules."
    />
  );
}